// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.0
//   protoc               v3.21.12
// source: finalizereview.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Section } from "./schema";

export const protobufPackage = "finalizereview";

export interface FinalizeReviewRequest {
  caseId: string;
  reviewedSections: Section[];
}

export interface FinalizeReviewResponse {
  success: boolean;
}

function createBaseFinalizeReviewRequest(): FinalizeReviewRequest {
  return { caseId: "", reviewedSections: [] };
}

export const FinalizeReviewRequest: MessageFns<FinalizeReviewRequest> = {
  encode(message: FinalizeReviewRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.caseId !== "") {
      writer.uint32(10).string(message.caseId);
    }
    for (const v of message.reviewedSections) {
      Section.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FinalizeReviewRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFinalizeReviewRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.caseId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.reviewedSections.push(Section.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FinalizeReviewRequest {
    return {
      caseId: isSet(object.caseId)
        ? globalThis.String(object.caseId)
        : isSet(object.case_id)
        ? globalThis.String(object.case_id)
        : "",
      reviewedSections: globalThis.Array.isArray(object?.reviewedSections)
        ? object.reviewedSections.map((e: any) => Section.fromJSON(e))
        : globalThis.Array.isArray(object?.reviewed_sections)
        ? object.reviewed_sections.map((e: any) => Section.fromJSON(e))
        : [],
    };
  },

  toJSON(message: FinalizeReviewRequest): unknown {
    const obj: any = {};
    if (message.caseId !== "") {
      obj.caseId = message.caseId;
    }
    if (message.reviewedSections?.length) {
      obj.reviewedSections = message.reviewedSections.map((e) => Section.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FinalizeReviewRequest>, I>>(base?: I): FinalizeReviewRequest {
    return FinalizeReviewRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FinalizeReviewRequest>, I>>(object: I): FinalizeReviewRequest {
    const message = createBaseFinalizeReviewRequest();
    message.caseId = object.caseId ?? "";
    message.reviewedSections = object.reviewedSections?.map((e) => Section.fromPartial(e)) || [];
    return message;
  },
};

function createBaseFinalizeReviewResponse(): FinalizeReviewResponse {
  return { success: false };
}

export const FinalizeReviewResponse: MessageFns<FinalizeReviewResponse> = {
  encode(message: FinalizeReviewResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FinalizeReviewResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFinalizeReviewResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.success = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FinalizeReviewResponse {
    return { success: isSet(object.success) ? globalThis.Boolean(object.success) : false };
  },

  toJSON(message: FinalizeReviewResponse): unknown {
    const obj: any = {};
    if (message.success !== false) {
      obj.success = message.success;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FinalizeReviewResponse>, I>>(base?: I): FinalizeReviewResponse {
    return FinalizeReviewResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FinalizeReviewResponse>, I>>(object: I): FinalizeReviewResponse {
    const message = createBaseFinalizeReviewResponse();
    message.success = object.success ?? false;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
